import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserGroupMapping, TaskGroupUsers, IMasterMessageType } from 'src/app/models/TasksAndGroups';
import { TasksAndGroupsService } from 'src/app/Services/TaskAndGroup/tasks-and-groups.service';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
import { ILocationDetails } from 'src/app/models/ILocationDetails';
import { IMessagesTasksInbox } from 'src/app/models/IMessagesTasksInbox';
import { NgxSpinnerService } from 'ngx-spinner';
import { forkJoin } from 'rxjs';
import { IPersonalInfo } from 'src/app/models/IPersonalInfo';
import { PatientSearchComponent } from 'src/app/patient-search/patient-search.component';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from 'src/app/Sharedservice/SharedService';
declare let $: any;
@Component({
  selector: 'app-messages-replay-forward',
  templateUrl: './messages-replay-forward.component.html',
  styleUrls: ['./messages-replay-forward.component.css']
})
export class MessagesReplayForwardComponent implements OnInit {
  ForwardMessagesForm: FormGroup;
  ViewMessagesdata: IMessagesTasksInbox;
  public result: any;
  public Type: string;
  toDate: Date;
  buttonName: string = '';
  selectedLocId: any;
  disableReply: boolean = false;
  disablePatientSearch: boolean = false;
  toAndcc = {
    height: 'auto',
    'min-height': '30px'
  }
  TaskId: number = 0;
  constructor(public dialog: MatDialog, private fb: FormBuilder, private schedulerservice: SchedularServiceService
    , private _taskandgroupservice: TasksAndGroupsService
    , public dialogRef: MatDialogRef<any>
    , private spinner: NgxSpinnerService
    , private toastr: ToastrService, private dateservice: SharedService
    , @Inject(MAT_DIALOG_DATA) public data: { taskObj: IMessagesTasksInbox, type: string }
    , private datePipe: DatePipe,) {
    this.toDate = new Date();

  }

  ngOnInit() {

    //   window.addEventListener('click', function(e){
    //     if ($('#showresut').contains(e.target)){
    //       alert("Clicked in Box");
    //     } else{
    //       alert("Clicked outside Box");
    //     }
    //   })
    this.getLocationDate();
    this.loadAllNewTaskBIndValues();
    $('textarea').keyup(function () {
      var characterCount = $(this).val().length,
        current = $('#current1'),
        maximum = $('#maximum1'),
        theCount = $('#the-count1');

      current.text(characterCount);


      /*This isn't entirely necessary, just playin around*/
      if (characterCount < 70) {
        current.css('color', '#666');
      }
      if (characterCount > 70 && characterCount < 90) {
        current.css('color', '#6d5555');
      }
      if (characterCount > 90 && characterCount < 100) {
        current.css('color', '#793535');
      }
      if (characterCount > 100 && characterCount < 120) {
        current.css('color', '#841c1c');
      }
      if (characterCount > 120 && characterCount < 139) {
        current.css('color', '#8f0001');
      }

      if (characterCount >= 140) {
        maximum.css('color', '#8f0001');
        current.css('color', '#8f0001');
        theCount.css('font-weight', 'bold');
      } else {
        maximum.css('color', '#666');
        theCount.css('font-weight', 'normal');
      }


    });
    this.ForwardMessagesForm = this.fb.group({
      priority: [''],
      dueDate: [''],
      ToUsersId: [''],
      CCUsersId: [''],
      locationId: [''],
      searchtxt: [''],
      groupNametxt: [''],
      messageTypeId: ['', Validators.required],
      patientName: [''],
      subject: [''],
      txtMessage: [''],
      isEmailNotify: [''],
      userSelected: [''],
      IsToCC: [''],
    });
    this.ViewMessagesdata = this.data.taskObj;
    this.TaskId = this.ViewMessagesdata[0].MessageTaskMasterId;
    this.getReplyMessages();
    this.Type = this.data.type;
    if (this.Type == 'F') {
      this.buttonName = 'Forward';
      this.messageType = 'Forward';
      this.disableReply = true;
    }
    else {
      this.getMessageInfoByTaskId();
      this.disableReply = true;
      this.buttonName = 'Reply';
      this.messageType = 'Reply';
    }
    this.ForwardMessagesForm.patchValue({
      locationId: 0
    })

  }

  public lstLocations: ILocationDetails[];
  usersList: UserGroupMapping[];
  usersList1: UserGroupMapping[];
  masterUserList: UserGroupMapping[] = [];
  GroupedUserList: TaskGroupUsers[] = [];
  GroupMasterUserList: TaskGroupUsers[] = [];
  public allMessageType: IMasterMessageType[];
  messageType: string = "";
  loadAllNewTaskBIndValues() {
    this.spinner.show();
    forkJoin(
      this.schedulerservice.getLocations(),
      this._taskandgroupservice.getAllMappedGroupUsers(0, "AllUsers"),
      this._taskandgroupservice.getTaskGroupedUsers(),
      this._taskandgroupservice.getmessagetype('0')).subscribe(([locationLst, mappedGroupUsers, taskGroupedUser, msgTypes]: any) => {
        this.lstLocations = locationLst;
        this.lstLocations = this.lstLocations.filter(a => a.active == true);
        this.manipultaedata(mappedGroupUsers);
        // this.loginUserEmail = this.usersList.filter(x => x.userId == sessionStorage.getItem("loginUserId"))[0].emailId;
        var useremailObj = this.usersList.filter(x => x.userId == sessionStorage.getItem("loginUserId"))
        if (useremailObj.length > 0) {
          this.loginUserEmail = useremailObj[0].emailId
        }
        this.GroupedUserList = taskGroupedUser;
        this.GroupMasterUserList = taskGroupedUser;
        this.allMessageType = msgTypes;
        this.allMessageType = this.allMessageType.filter(x => x.isActive == true)
        this.spinner.hide();
        this.BindTaskMessages(this.ViewMessagesdata[0]);
      }
        , (err: any) => {
          console.log(err);
          this.spinner.hide();
        }
      );
  }
  ReplyForwardMessagesList: IMessagesTasksInbox[] = [];
  getReplyMessages() {
    this._taskandgroupservice.GetForwardReplyByTaskId(this.TaskId).subscribe(data => {
      this.ReplyForwardMessagesList = data
      if (this.ReplyForwardMessagesList.length > 0) {
        if (this.Type == 'F') {
          this.ReplyForwardMessagesList = this.ReplyForwardMessagesList.filter(x => x.MailStatus == 2)
        } else if (this.Type == 'R') {
          this.ReplyForwardMessagesList = this.ReplyForwardMessagesList.filter(x => x.MailStatus == 3)
        }
        this.ReplyForwardMessagesList.forEach(x => {
          if (x.DueDate == '0001-01-01T00:00:00') {
            x.DueDate = "";
          }
          this.ViewMessagesdata[0].PatientName = x.PatientName
          this.searchPatName = x.PatientName;

        })
      }

    },
      (err: any) => {
        console.log(err)
      });
  }

  manipultaedata(data: any) {
    this.masterUserList = data;
    this.usersList = data;
  }

  OnLocationUserFilter(event: any) {
    this.searchfilter(this.ForwardMessagesForm.controls['searchtxt'].value)
  }
  searchfilterevent(event) {
    let txt = event.target.value.toLowerCase();
    this.searchfilter(txt)
  }
  searchfilter(searchtxt: string) {
    let txt = searchtxt;
    let obj: UserGroupMapping[] = [];
    let selectLocId = this.ForwardMessagesForm.controls['locationId'].value
    if (selectLocId == '0' || selectLocId == "") {
      obj = this.masterUserList;
    } else {
      obj = this.masterUserList.filter(x => x.userLocations.includes(selectLocId));
    }

    if (txt != '')
      obj = obj.filter(x => x.userName.toLowerCase().includes(txt));

    this.usersList = obj
  }
  searchfilter1(searchtxt: string) {
    let txt = searchtxt;
    let obj: UserGroupMapping[] = [];
    let selectLocId = this.ForwardMessagesForm.controls['locationId'].value
    if (selectLocId == '0' || selectLocId == "") {
      obj = this.masterUserList;
    } else {
      obj = this.masterUserList.filter(x => x.userLocations.includes(selectLocId));
    }

    if (txt != '')
      obj = obj.filter(x => x.userName.toLowerCase().includes(txt));

    this.usersList1 = obj
  }

  GroupNamesearchfilterevent(event) {
    let txt = event.target.value.toLowerCase();
    if (txt != "")
      this.GroupedUserList = this.GroupMasterUserList.filter(x => x.groupName.toLowerCase().includes(txt))
    else
      this.GroupedUserList = this.GroupMasterUserList;
  }

  CCSelectUsers: any = [];
  ToSelectUsers: any = [];
  onUserClick(ele: any) {
    switch (this.isTo) {
      case false:
        if (this.CCSelectUsers.some(x => x.UserID == ele.userId)) {
          // alert("user exist");
          this.toastr.warning('This user already added')
          return
        } else {
          let ccObj: any = {
            UserID: ele.userId,
            UserName: ele.userFullName,
            EmailId: ele.emailId,
            GroupId: "0"
          }
          this.CCSelectUsers.push(ccObj);
        }
        break;
      case true:
        if (this.ToSelectUsers.some(x => x.UserID == ele.userId)) {
          //alert("user exist");
          this.toastr.warning('This user already added')
          return
        } else {
          let toObj: any = {
            UserID: ele.userId,
            UserName: ele.userFullName,
            EmailId: ele.emailId,
            GroupId: "0"
          }
          this.ToSelectUsers.push(toObj);
        }
        break;
      default:
        //alert("select")
        break;
    }
    $('#spanid').text('');

    $('#spanid').focus();
    $('#showresut').hide()
  }
  onUserClickCC(ele: any) {
    switch (this.isTo) {
      case false:
        if (this.CCSelectUsers.some(x => x.UserID == ele.userId)) {
          //alert("user exist");
          this.toastr.warning('This user already added')
          return
        } else {
          let ccObj: any = {
            UserID: ele.userId,
            UserName: ele.userFullName,
            EmailId: ele.emailId,
            GroupId: "0"
          }
          this.CCSelectUsers.push(ccObj);
        }
        break;
      case true:
        if (this.ToSelectUsers.some(x => x.UserID == ele.userId)) {
          //alert("user exist");
          this.toastr.warning('This user already added')
          return
        } else {
          let toObj: any = {
            UserID: ele.userId,
            UserName: ele.userFullName,
            EmailId: ele.emailId,
            GroupId: "0"
          }
          this.ToSelectUsers.push(toObj);
        }
        break;
      default:
        //alert("select")
        break;
    }
    $('#spanidcc').text('');
    $('#spanidcc').focus();
    $('#showresutcc').hide()

  }
  OnGroupNameSelect(ele) {
    switch (this.isTo) {
      case false:
        let ccuserJson = JSON.parse(ele.userJsonData);
        let ccjsonList = ccuserJson.UserData;
        if (this.CCSelectUsers.filter(x => Number(x.GroupId) == ele.groupId).length > 0) {
          this.toastr.warning('This group has been already added')
          return;
        }
        ccjsonList.forEach(element => {
          if (!(this.CCSelectUsers.some(x => x.UserID == element.UserID))) {
            this.CCSelectUsers.push(element);
          }
        });
        // let ccObj1: any = {
        //   UserID: ccjsonList.map(x => x.UserID).toString(),
        //   UserName: ele.groupName,
        //   EmailId: '',
        //   GroupId: ele.groupId
        // }
        // this.CCSelectUsers.push(ccObj1);
        break;
      case true:
        let touserJson = JSON.parse(ele.userJsonData);
        let tojsonList = touserJson.UserData;
        if (this.ToSelectUsers.filter(x => Number(x.GroupId) == ele.groupId).length > 0) {
          this.toastr.warning('This group has been already added')
          return;
        }
        tojsonList.forEach(element => {
          if (!(this.ToSelectUsers.some(x => x.UserID == element.UserID))) {
            this.ToSelectUsers.push(element);
          }
        });
        // let ccObj2: any = {
        //   UserID: tojsonList.map(x => x.UserID).toString(),
        //   UserName: ele.groupName,
        //   EmailId: '',
        //   GroupId: ele.groupId
        // }
        // this.ToSelectUsers.push(ccObj2);
        break;
      default:
        //alert("select")
        break;
    }
  }
  locationDate: string = "";
  getLocationDate() {
    this.dateservice.getservercurrentdate().subscribe(async result => {
      await result;
      this.locationDate = result;
    });
  }
  _msgtask: IMessagesTasksInbox;
  loginUserEmail: string = '';
  searchPatName: string = '';
  searchPatName1: string = '';
  CreateTask() {
    this.spinner.show();
    if (this.ToSelectUsers.length == 0) {
      this.toastr.error("Please select TO user");
      this.spinner.hide();
    } else {
      this._msgtask = new IMessagesTasksInbox();
      this._msgtask.FromUserId = encodeURIComponent(sessionStorage.getItem("userId"));
      this._msgtask.CreatedOn = this.locationDate;
      this._msgtask.Priority = this.ForwardMessagesForm.value.priority;
      this._msgtask.PriorityName = this.ForwardMessagesForm.value.priority == "1" ? "High" : this.ForwardMessagesForm.value.priority == "2" ? "Medium" : "Low";
      this._msgtask.DueDate = this.datePipe.transform(this.ForwardMessagesForm.value.dueDate, "MM/dd/yyyy");
      this._msgtask.MailDueDate = this.datePipe.transform(this.ForwardMessagesForm.value.dueDate, "MM/dd/yyyy");
      this._msgtask.ToUserIds = this.ToSelectUsers.map(x => encodeURIComponent(x.UserID)).toString();
      this._msgtask.CCUserIds = this.CCSelectUsers.map(x => encodeURIComponent(x.UserID)).toString();
      this._msgtask.TypeId = this.ForwardMessagesForm.value.messageTypeId;
      let msgList = this.allMessageType.filter(x => x.messagesTypeId == this.ForwardMessagesForm.value.messageTypeId)
      if (msgList.length > 0) {
        if (msgList[0].messagesType == "General") {
          this._msgtask.Status = 4; // General message type
          this._msgtask.TypeName = msgList[0].messagesType
        } else {
          // this._msgtask.Status = 1;
          if (this.ViewMessagesdata[0].Status == "") {
            this._msgtask.Status = 1
            this._msgtask.TypeName = msgList[0].messagesType
          } else {
            this._msgtask.Status = this.ViewMessagesdata[0].Status;
          }
        }
      }
      this.ToSelectUsers.forEach(x => { x.UserID = encodeURIComponent(x.UserID) });
      this.CCSelectUsers.forEach(x => { x.UserID = encodeURIComponent(x.UserID) });
      // this._msgtask.PatientId = this.ViewMessagesdata[0].PatientId;
      this._msgtask.PatientId = this.searchPatientId;
      this._msgtask.PatientName = this.searchPatName1;// this.ViewMessagesdata[0].patientName;
      this._msgtask.Subject = this.ForwardMessagesForm.value.subject;
      this._msgtask.Note = this.ForwardMessagesForm.value.txtMessage;
      this._msgtask.IsSendEmailNotification = this.ForwardMessagesForm.value.isEmailNotify;
      this._msgtask.CreatedBy = encodeURIComponent(sessionStorage.getItem("userId"));
      this._msgtask.LocationId = Number(sessionStorage.getItem("LocationId"));
      this._msgtask.ToUserIdList = this.ToSelectUsers;
      this._msgtask.CCUserIdList = this.CCSelectUsers;
      this._msgtask.FacilityId = Number(sessionStorage.getItem("FacilityId"));
      this._msgtask.FromUserEmail = this.loginUserEmail;
      if (this.Type == 'F') {
        this._msgtask.TypeOfMessage = 'Forward';
        this._msgtask.OldTaskId = this.ViewMessagesdata[0].MessageTaskMasterId;
        // this._msgtask.IsFroward = false;
      } else if (this.Type == 'R') {
        this._msgtask.TypeOfMessage = 'Replay';
        this._msgtask.OldTaskId = this.ViewMessagesdata[0].MessageTaskMasterId;
        // this._msgtask.IsFroward = true;
      }
      this._taskandgroupservice.SaveTasksInfo(this._msgtask).subscribe(data => {
        this.dialogRef.close(true);
        if (this.Type == 'F') {
          this.toastr.success("Message Forwarded Successfully")
        } else {
          this.toastr.success("Message Replied Successfully")
        }
        this.spinner.hide();
        this.disablePatientSearch = true;
        // this.BindTaskMessages(this.ViewMessagesdata[0]);
        this.getMessageInfoByTaskId()
        // this.getReplyMessages();
        // this.loadAllNewTaskBIndValues();
      },
        (err: any) => {
          console.log(err);
          this.spinner.hide();
        })
    }
  }
  CloseDailog() {
    this.dialogRef.close(false);
  }
  // ClearTaskValues() {

  // }
  isTo: any = true;
  onFocus(val: boolean) {
    this.isTo = val
  }

  //******Patient Search */
  patientInformation: IPersonalInfo;
  searchPatientId: number = 0;
  checkPatientId: boolean = false;
  onClickPatientSearch() {
    sessionStorage.setItem("ispatSerachPopup", "True");
    const dialogRef = this.dialog.open(PatientSearchComponent, {
      width: '1180px',
      maxWidth:'auto',
       height: 'auto',
      data: { action: true }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined && result != '') {
        this.patientInformation = result;
        this.checkPatientId = true;
        this.searchPatientId = this.patientInformation.patientId;
        this.searchPatName = this.patientInformation.name + '  ( ' + (this.transform(this.patientInformation.dob) + ' )');
        this.searchPatName1 = this.patientInformation.name;
        this.ForwardMessagesForm.patchValue({
          patientName: this.patientInformation.name + '  ( ' + (this.transform(this.patientInformation.dob) + ' )')//patDOB patientId //dPatId
        })
      }
    });
  }
  transform(value: string): string {
    if (value && value != undefined) {
      var datePipe = new DatePipe("en-US");
      value = datePipe.transform(value, 'MM/dd/yyyy');
    }
    return value;
  }
  RemoveUser(userObj: any, type: string, index: number) {
    switch (type) {
      case 'To':
        this.ToSelectUsers.splice(index, 1);
        break;
      case 'CC':
        this.CCSelectUsers.splice(index, 1);
        break;
    }
  }

  validateDate(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 47) {
      event.preventDefault();
      return false;
    }
    return true;
  }
  fromUserName: string = '';
  fromCreated: any;
  minDate = new Date();
  BindTaskMessages(databind: IMessagesTasksInbox) {

    if (this.Type == 'R') {
      //** CC User list */
      if (databind.AllReplyCCUserIds != null) {
        // var splitCCusers = databind.CCUserIds.split(',')
        var splitCCusers = databind.AllReplyCCUserIds.split(',')
        if (splitCCusers.length > 0) {
          splitCCusers.forEach(y => {
            let ccUserObj = this.usersList.filter(x => x.userId == y.trim());
            if (ccUserObj.length > 0) {
              let ccObj: any = {
                UserID: ccUserObj[0].userId,
                UserName: ccUserObj[0].userFullName,
                EmailId: ccUserObj[0].emailId,
                GroupId: "0",
              }
              this.CCSelectUsers.push(ccObj);
            }


          });
        }

      }

      //** CC User list */
      if (databind.AllReplyToUserIds != null) {
        //var splitTousers = databind.ToUserIds.split(',')
        var splitTousers = databind.AllReplyToUserIds.split(',')
        if (splitTousers.length > 0) {
          splitTousers.forEach(y => {
            let filterToUserObj = this.usersList.filter(x => x.userId == y.trim());
            if (filterToUserObj.length > 0) {
              let toUserObj: any = {
                UserID: filterToUserObj[0].userId,
                UserName: filterToUserObj[0].userFullName,
                EmailId: filterToUserObj[0].emailId,
                GroupId: "0",
              }
              this.ToSelectUsers.push(toUserObj);
            }
          });
          //From UserId

          let formUserObj = this.ToSelectUsers.filter(x => x.UserID == databind.FrmUserId);
          if (formUserObj.length == 0) {
            let filterFromUserObj = this.usersList.filter(x => x.userId == databind.FrmUserId);
            if (filterFromUserObj.length > 0) {
              let frmUserObj: any = {
                UserID: filterFromUserObj[0].userId,
                UserName: filterFromUserObj[0].userFullName,
                EmailId: filterFromUserObj[0].emailId,
                GroupId: "0",
              }
              this.ToSelectUsers.push(frmUserObj);
            }
          }
        }
      }

      this.fromUserName = sessionStorage.getItem("username")
      this.fromCreated = new Date();

      this.ForwardMessagesForm.patchValue({
        patientName: databind.PatientName,
        subject: databind.Subject,
        messageTypeId: databind.TypeId,
        priority: databind.Priority,
        dueDate: databind.DueDate
      });
    }
    else {
      this.ToSelectUsers = [];
    }
    this.fromUserName = sessionStorage.getItem("username")
    this.fromCreated = new Date();
    this.ForwardMessagesForm.patchValue({
      patientName: databind.PatientName,
      subject: databind.Subject,
      messageTypeId: databind.TypeId,
      priority: databind.Priority
      , dueDate: databind.DueDate
    });
    if (databind.PatientId != 0 && databind.PatientId != undefined &&
      databind.PatientId != null) {
      this.searchPatientId = databind.PatientId;
      this.searchPatName1 = databind.PatientName;
      this.ViewMessagesdata[0].PatientName = this.searchPatName;
      if (this.searchPatName == "") {
        this.ViewMessagesdata[0].PatientName = databind.PatientName;
      }
      this.ViewMessagesdata[0].DueDate = databind.DueDate;
      // this.ViewMessagesdata[0].PatientName=databind.PatientName + '  ( ' + (this.transform(databind.dob) + ' )')

      this.disablePatientSearch = true;
    } else {
      this.disablePatientSearch = false;
    }
    if (databind.DueDate == '0001-01-01T00:00:00') {
      databind.DueDate = "";
    }

  }
  funAutoSuggust() {
    var spanid = $('#spanid').text();
    // $('#sel2').find('option[text=spanid]').val()
    $('#showresut').show()
    this.searchfilter1(spanid.toLowerCase().trim());
  }
  funAutoSuggustCC() {
    var spanidcc = $('#spanidcc').text();
    // $('#sel2').find('option[text=spanid]').val()
    $('#showresutcc').show()
    this.searchfilter1(spanidcc.toLowerCase().trim());
  }

  isTofocus() {
    $('#spanid').focus();
    this.isTo = true;
  }

  isCCFocus() {
    $('#spanidcc').focus();
    this.isTo = false;
  }
  checkEmail: boolean = false;
  checkEmailNotification(event) {
    if (event.target.checked == true) {
      this.checkEmail = true;
    } else {
      this.checkEmail = false;
    }
  }

  allMessagesInbox: IMessagesTasksInbox;
  getMessageInfoByTaskId() {

    this._taskandgroupservice.GetInboxMessageByTaskId(this.TaskId).subscribe(data => {
      this.allMessagesInbox = data
      // alert(this.allMessagesInbox.PatientId +'Pat Name :: '+ this.allMessagesInbox.PatientName)
      this.allMessagesInbox.AllReplyCCUserIds = ''
      this.allMessagesInbox.AllReplyToUserIds = ''

      this.searchPatName = this.allMessagesInbox.PatientName;
      this.BindTaskMessages(this.allMessagesInbox)
      //  this.ViewMessagesdata.PatientName=this.allMessagesInbox.PatientName;
      //  this.ViewMessagesdata.DueDate=this.allMessagesInbox.DueDate;
      //this.ViewMessagesdata[0] = this.allMessagesInbox;
    },
      (err: any) => {
        console.log(err)
        //this.spinner.hide();
      });
  }
}
